onComplete(function() {
	// CO2 calculator. Constants and formulas are those of the calculator on the old 2Return website.
	document.querySelectorAll('[data-calculator]').forEach(function(root) {
		var values = {
			stackPattern: { 'false': 700, 'true': 561 },
			carbonPerTonKm: 82,
			carbonPerM3: 622,
			carbonPerKgOfPallet: 1.3,
			eqFactor: 1,
			tarraWeight: 3500,
			timberPerKgPallet: 0.0021,
		};

		var number = function(name, divider) {
			var input = root.querySelector('input[name="' + name + '"]');
			return input ? Number.parseFloat(input.value) / (divider || 1) : 0;
		};

		var update = function() {
			var weight = number('pallet-weight');
			var repair = number('pallet-repair', 100);
			var newWood = number('pallet-new', 100);
			var scrap = number('pallet-scrap', 100);
			var distance = number('transport-distance');
			var cycles = number('transport-cycles');
			var efficiency = number('transport-efficiency', 100);
			var stackInput = root.querySelector('input[name="pallet-stack"]:checked');
			var stackFactor = values.stackPattern[stackInput ? stackInput.value : 'false'];

			var oneWay = weight * values.carbonPerKgOfPallet;
			var sum = 0;
			if (cycles >= 1) {
				var endOfLife = oneWay / cycles;
				var repairCarbon = repair * weight * values.timberPerKgPallet * 0.1 * newWood * values.carbonPerM3;
				var scrapCarbon = weight * scrap * values.carbonPerM3 * values.timberPerKgPallet;
				var transport = (stackFactor * weight + values.tarraWeight) * distance * values.carbonPerTonKm / 1000000
					/ (stackFactor * efficiency) * values.eqFactor;
				sum = endOfLife + repairCarbon + scrapCarbon + transport;
			}

			var results = {
				'emissions': oneWay,
				'savings-absolute': oneWay - sum,
				'savings-percentage': oneWay > 0 ? ((oneWay - sum) / oneWay) * 100 : 0,
			};
			Object.keys(results).forEach(function(key) {
				var output = root.querySelector('[data-calculator-result="' + key + '"]');
				if (output) {
					output.textContent = results[key].toFixed(2);
				}
			});
		};

		root.querySelectorAll('input').forEach(function(input) {
			input.addEventListener('input', function() {
				var output = root.querySelector('[data-calculator-output="' + input.name + '"]');
				if (output) {
					output.textContent = input.value;
				}
				update();
			});
		});
		update();
	});
});
